import React, { useState, useEffect, useContext } from 'react';
import FileBrowser, { Icons } from 'react-keyed-file-browser';
import Moment from 'moment';
import { AuthContext } from '../../containers/App';

import * as Antd from 'antd';
import * as AntdIcons from '@ant-design/icons';

import * as COM from '.';
import Axios from 'axios';

export const FileExplorer = (props) => {

    const auth = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);

    const loadFiles = async (path = null, createWhenNotExists = false) => {
        try {
            setLoading(true);
            let { data } = await Axios.get(`${process.env.REACT_APP_API_BASE_URI}/api/files`, {
                headers: {
                    Authorization: `Bearer ${auth.accessToken}`
                },
                params: {
                    path: path ? path : '',
                    createWhenNotExists: createWhenNotExists
                }
            });
            setFiles(data);
        } catch (err) {
            Antd.message.error('Oops, something went wrong!');
        }
        setLoading(false);
    }

    useEffect(() => {
        if (props.path) {
            loadFiles(props.path, props.createWhenNotExists ? props.createWhenNotExists : false);
        } else {
            loadFiles();
        }
    }, [])

    return (
        <>
            {props.allowUpload
                ? <Antd.Upload.Dragger                    
                    showUploadList={false}
                    multiple={true}
                    customRequest={async (options) => {
                        const { onSuccess, onError, file } = options;
                        var formData = new FormData();
                        formData.append("file", file);
                        try {
                            await Axios.post(`${process.env.REACT_APP_API_BASE_URI}/api/files`, formData, {
                                headers: {
                                    Authorization: `Bearer ${auth.accessToken}`,
                                    'Content-Type': 'multipart/form-data',                                    
                                },
                                params: {
                                    path: props.path ? props.path : ''
                                }
                            });
                            Antd.message.success('File successfuly uploaded')
                            onSuccess();
                        } catch (err) {
                            Antd.message.error('Oops, file could not be uploaded!')
                            onError();
                        }
                    }}
                    onChange={(info) => {
                        if (info.file.status === 'done') {
                            if (props.path) {
                                loadFiles(props.path);
                            } else {
                                loadFiles();
                            }
                        }
                    }}
                >
                    <p className="ant-upload-drag-icon">
                        <AntdIcons.InboxOutlined />
                    </p>
                    <p className="ant-upload-text">
                        Click or drag file to this area to upload
                    </p>
                    <p className="ant-upload-hint">
                        Support for a single or bulk upload.
                    </p>
                </Antd.Upload.Dragger>
                : null}
            <FileBrowser
                files={files}
                icons={Icons.FontAwesome(4)}
                canFilter={false}
                renderStyle={'table'}
                nestChildren={false}
                icons={{
                    File: <AntdIcons.FileOutlined />,
                    Image: <AntdIcons.FileImageOutlined />,
                    PDF: <AntdIcons.FilePdfOutlined />,
                    Rename: <AntdIcons.EditOutlined />,
                    Folder: <AntdIcons.FolderOutlined />,
                    FolderOpen: <AntdIcons.FolderOpenOutlined />,
                    Delete: <AntdIcons.DeleteOutlined />,
                    Loading: <AntdIcons.LoadingOutlined />,
                }}
                detailRenderer={(a, b) => {
                    let link = props.path
                        ? `${process.env.REACT_APP_API_BASE_URI}/api/file?filename=` + props.path + a.file.key
                        : `${process.env.REACT_APP_API_BASE_URI}/api/file?filename=` + a.file.key;
                    return (
                        <Antd.PageHeader
                            title={a.file.name}
                            extra={[
                                <a
                                    href={link}
                                    target="_blank"
                                >
                                    Download
                                </a>,
                            ]}
                        />
                    );
                }}
            />
        </>
    )
};